import gql from "graphql-tag";

export const AGENT_OVERVIEW_REPORT = gql`
  query (
    $skip: Int
    $take: Int
    $fromDate: String
    $toDate: String
    $orderBy: String
    $orderDirection: String
  ) {
    agentOverviewReport(
      skip: $skip
      take: $take
      fromDate: $fromDate
      toDate: $toDate
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      agentId
      agentName
      agentUsername
      totalDownlineCount
      newDownlineCount
      totalDownlineDepositAmount
      totalDownlineDepositCount
      highestDownlineDepositAmount
      firstDepositorCount
      totalDownlineWithdrawalAmount
      totalDownlineWithdrawalCount
      highestDownlineWithdrawalAmount
      totalDownlineIncrementAmount
      totalDownlineDecrementAmount
      totalDownlineBonusAmount
      totalDownlineFreeCreditAmount
      totalDownlineRebateAmount
      totalDownlineReferralAmount
      totalDownlineRewardAmount
      totalDownlineCommissionAmount
      totalDownlineDailyAttendanceAmount
      totalDownlineWeeklyAttendanceAmount
      totalDownlineCreditIn
      totalDownlineCreditOut
      totalGrossProfit
    }
  }
`;
